export const MIN_PASSWORD_LENGTH = 8;
export const PASSWORD_MIN_LENGTH_MESSAGE = `A senha deve ter no mínimo ${MIN_PASSWORD_LENGTH} caracteres`;
export const PASSWORD_PLACEHOLDER = `Mínimo ${MIN_PASSWORD_LENGTH} caracteres`;
